import React from "react";

export const ResultPanel: React.FC<{}> = ({ children }) => (
  <div className="bg-blue-3 py-8 px-5 flex flex-col space-y-5">{children}</div>
);
